

jQuery(document).ready(function(){
    
    if (jQuery(".openModal").length > 0)
  {
      jQuery(".openModal").on("click",function(){
          thismodal = jQuery(this).data("modal");
          console.dir(thismodal)
          jQuery(thismodal).show();
      });

      jQuery(".popupmodal").find(".close").on("click",function(){
          
        jQuery(thismodal).hide();
      })
  }

    jQuery(".section-content.anim-el").each(function(){
        jQuery(this).children().wrapAll("<div class='slidecontents'></div>")
    })

})